import { request } from 'ice';
import { INBOUNDSERVICE } from '@/const';

// 入库面板tip
async function getPersonDatas(data) {
  return await request({
    url: `${INBOUNDSERVICE}/employeeBoard/getEmployeeOnlineAndFreeNum`,
    method: 'POST',
    data,
  });
}

export { getPersonDatas };
